package pwgs.ui.scenes.leaderboardlistscene

import kotlinx.browser.window


class LeaderboardListControllerFe(props: LeaderboardListSceneProps, scene: MLeaderboardListScene) : ALeaderboardListControllerFe(props, scene) {

    override fun createInitialModel() : LeaderboardListSceneModel {
        return LeaderboardListSceneModel(listOf())
    }

    override fun init() {
        call_load()
    }

    fun onCreateLeaderboardButtonClicked() {
        model.isLoading = true
        render()

        call_showCreateDialog()
    }

    fun onSubmitCreate() {
        model.createLeaderboardDialogModel!!.isLoading = true
        render()

        call_create()
    }

    fun onCancelCreate() {
        model.createLeaderboardDialogModel = null
        render()
    }

    fun onDeleteLeaderboardClicked(name: String) {
        if (!window.confirm("Are you sure you want to delete the leaderboard: $name?")) {
            return
        }

        call_delete(name)
    }


}

